import { getPlatformTableListFiltersTeamQueryKey, PlatformFilter } from '@cloudquery/api-platform';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useQueryClient } from '@tanstack/react-query';

import { useBooleanState, MenuActions, CLOUD_ASSET_TABLE_NAME } from 'shared/base';

import { SavedFiltersPanelDeleteDialog } from '../../dialogs/deleteDialog';
import { FilterFormDialog } from '../../dialogs/filterFormDialog';
import { SavedFiltersPanelShareDialog } from '../../dialogs/shareDialog';

interface Props {
  anchorEl: HTMLButtonElement;
  filter: PlatformFilter;
  menuId: string;
  menuToggleId: string;
  onClose: () => void;
  open: boolean;
  teamName: string;
}

export function SavedFiltersPanelActionsMenu({
  anchorEl,
  filter,
  menuId,
  menuToggleId,
  onClose,
  open,
  teamName,
}: Props) {
  const queryClient = useQueryClient();
  const [deleteDialogShown, showDeleteDialog, hideDeleteDialog] = useBooleanState(false);
  const [shareDialogShown, _showShareDialog, hideShareDialog] = useBooleanState(false);
  const [editDialogShown, showEditDialog, hideEditDialog] = useBooleanState(false);
  const handleDeleted = async () => {
    queryClient.invalidateQueries({
      queryKey: getPlatformTableListFiltersTeamQueryKey(teamName, CLOUD_ASSET_TABLE_NAME),
    });

    hideDeleteDialog();
  };

  const actions = [
    // Descoped for V1 - public/private sharing is not yet implemented
    // {
    //   icon: ShareIcon,
    //   id: 'share',
    //   label: 'Share',
    //   onClick: showShareDialog,
    // },
    {
      icon: EditIcon,
      id: 'edit',
      label: 'Edit filter',
      onClick: showEditDialog,
    },
    {
      icon: DeleteIcon,
      id: 'delete',
      isDangerous: true,
      label: 'Delete',
      onClick: showDeleteDialog,
    },
  ];

  return (
    <>
      <MenuActions
        actions={actions}
        anchorEl={anchorEl}
        id={menuId}
        onClose={onClose}
        open={open}
        toggleId={menuToggleId}
      />
      <FilterFormDialog
        filter={filter}
        onClose={hideEditDialog}
        onSaved={hideEditDialog}
        open={editDialogShown}
      />
      <SavedFiltersPanelShareDialog
        filterId={filter.id}
        onClose={hideShareDialog}
        open={shareDialogShown}
        teamName={teamName}
      />
      <SavedFiltersPanelDeleteDialog
        filter={filter}
        onClose={hideDeleteDialog}
        onClosed={hideDeleteDialog}
        onDeleted={handleDeleted}
        open={deleteDialogShown}
      />
    </>
  );
}
